export enum WalletLogType {
  INC = 'inc',
  DEC = 'dec'
}
